import { useSettingsCollection } from "@toolkit/Framework/Store/Context/ContextHooks";
import { FC, useEffect } from "react";

const ExperimentsSnippets: FC = () => {
    const { extensionExperimentsOptimizelyWebSettings } = useSettingsCollection();

    useEffect(() => {
        const scripts: Array<HTMLScriptElement> = [];

        if (extensionExperimentsOptimizelyWebSettings) {
            const { enableOptimizelyWebExperiments, snippetIds } = extensionExperimentsOptimizelyWebSettings;
            if (enableOptimizelyWebExperiments && snippetIds) {
                snippetIds.split(",").forEach((id: string) => {
                    const script = document.createElement("script");
                    script.src = `https://cdn.optimizely.com/js/${id}.js`;

                    document.head.appendChild(script);
                    scripts.push(script);
                });
            }
        }

        return () => {
            scripts.forEach(script => document.head.removeChild(script));
        };
    }, []);

    return null;
};

export default ExperimentsSnippets;
